require('../fhApp/currentUser/currentUser');

angular.module('app.redeemPromo.redeemPromoService', [
  'app.currentUser'
])
  .factory('app.redeemPromo.redeemPromoService', [
    '$http', '$httpParamSerializerJQLike', '$q', 'currentUser', '$rootScope',
    function ($http, $httpParamSerializerJQLike, $q, currentUser, $rootScope) {
      'use strict';

      let promotion = {
        plan: null,
        error: null,
        retrievePlanFromPromo: function (promo_code) {
          if(promotion.plan) {
            promotion.plan = null;
          }

          let deferred = $q.defer();

          $http.get(window.location.api('promotions/plan_by_promo_code/' + promo_code))
            .then(function (response) {
              let data = response.data;
              data.status = response.status;
              let resolve_now = true;

              if (data) {
                promotion.plan = data;

                if(currentUser.subscriptions.recurly) {
                  for (let i = 0; i < promotion.plan.length ; i++) {
                    if(currentUser.subscriptions.recurly.plan_code === promotion.plan[i].plan_code) {
                      promotion.plan.splice(i, 1);
                    }
                  }
                }

                if (data.error) {
                  resolve_now = false;

                  promotion.error = data.error;
                  deferred.reject(data);
                } else {
                  promotion.error = null;
                }
              }

              if (resolve_now) {
                deferred.resolve(data);
              }
            });

          return deferred.promise;
        }
      };
      return promotion;
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/promo/redeemPromoService.js